import { Box, Skeleton } from '@mui/material';
import { FC } from 'react';
import { GeneralPatientInfoSkeleton } from '../../../../shared/general-patient-info/general-patient-info.skeleton';

export const PatientDetailsSectionSkeleton: FC = () => {
  return (
    <>
      <GeneralPatientInfoSkeleton />
      <Box sx={{ margin: '0 25px' }}>
        <Box sx={{ marginTop: '10px', display: 'flex', flexDirection: 'column' }}>
          <Skeleton variant="text" sx={{ height: '15px', width: '55px' }} />
          <Skeleton variant="text" sx={{ height: '16px', width: '35px', marginTop: '2px' }} />
        </Box>
      </Box>
    </>
  );
};
